export const EXPORT_FORMATS = ["json", "csv", "xml"] as const;

export type ExportFormat = (typeof EXPORT_FORMATS)[number];

export function exportFormatLabel(format: ExportFormat): string {
  return format.toUpperCase();
}

export function exportSuccessMessage(subject: string, format: ExportFormat): string {
  return `${subject} exported as ${exportFormatLabel(format)}.`;
}

export function exportErrorMessage(
  subject: string,
  format: ExportFormat,
  error: unknown
): string {
  const prefix = `${subject} could not be exported as ${exportFormatLabel(format)}`;
  return error instanceof Error && error.message ? `${prefix}: ${error.message}` : `${prefix}.`;
}
